import './Ticket.css';
import React from 'react';
import { Event } from '../../../../../model/event';
import { Tabs } from '../../../../../components/Tabs/Tabs';
import { useRouterParam } from '../../../../../model/history';
import { eventPath } from '../../../../../routes';
import { Design } from './Design';
import { Prices } from '../Prices/Prices';
import { Print } from './Print';
import { Redirect } from 'react-router-dom';
import { t } from '../../../../../locales/translate';
import { Stack } from '../../../../../components/Stack/Stack';
import { Codes } from './Codes';
import { Resale } from './Resale';

interface Section {
  id: string;
  title: string;
  render: (event: Event) => JSX.Element;
}

const sections: Section[] = [
  {
    id: 'print',
    title: t.model.ticket.issueTickets,
    render: (event) => <Print event={event} />,
  },
  {
    id: 'local-pricing',
    title: t.model.ticket.localPricing,
    render: (event) => <Prices local event={event} />,
  },
  {
    id: 'system-pricing',
    title: t.model.ticket.systemPricing,
    render: (event) => <Prices event={event} />,
  },
  {
    id: 'design',
    title: t.model.ticket.design,
    render: (event) => <Design event={event} />,
  },
  {
    id: 'codes',
    title: t.model.ticket.codes,
    render: (event) => <Codes event={event} />,
  },
  {
    id: 'resale',
    title: t.model.ticket.resale,
    render: (event) => <Resale event={event} />,
  },
];

export function Ticket({ event }: { event: Event }): JSX.Element {
  const { subsection } = useRouterParam<{ subsection?: string }>();
  if (!subsection) {
    return <Redirect to={`${eventPath(event.slug)}/ticket/print`} />;
  }

  return (
    <Stack size="lg">
      <Tabs
        displayAsPills
        tabGroups={[
          sections.map((section) => ({
            title: section.title,
            active: subsection === section.id,
            path: `${eventPath(event.slug)}/ticket/${section.id}`,
          })),
        ]}
      />
      {sections.find((e) => e.id === subsection)?.render(event)}
    </Stack>
  );
}
